export const alertAction = (text: string) => {
  alert(text);
};



// WEBPACK FOOTER //
// ./src/actions/alert.ts